"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0039 9c-2.4853 0-4.5 2.0147-4.5 4.5s2.0147 4.5 4.5 4.5c2.4852 0 4.5-2.0147 4.5-4.5s-2.0148-4.5-4.5-4.5zm-2.5 4.5c0-1.3807 1.1192-2.5 2.5-2.5 1.3807 0 2.5 1.1193 2.5 2.5s-1.1193 2.5-2.5 2.5c-1.3808 0-2.5-1.1193-2.5-2.5z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 2C10.0179 2 8.118 3.4206 6.7324 5.1976c-1.4193 1.8202-2.492 4.247-2.7277 6.707-.236 2.4632.3658 4.9597 1.7274 6.8644C7.1094 20.6957 9.2591 22 12.0001 22c2.7409 0 4.8907-1.3043 6.268-3.2309 1.3617-1.9048 1.9636-4.4012 1.7275-6.8645-.2357-2.46-1.3084-4.8868-2.7278-6.707C15.8822 3.4206 13.9822 2 12.0001 2zM5.9956 12.0954c.1955-2.04 1.1017-4.1132 2.314-5.668C9.5556 4.8294 10.9399 4 12 4c1.0601 0 2.4445.8294 3.6906 2.4274 1.2123 1.5548 2.1186 3.628 2.3141 5.668.1951 2.0367-.3127 4.0403-1.3637 5.5105C15.6057 19.0543 14.0398 20 12.0001 20c-2.0398 0-3.6056-.9457-4.641-2.394-1.051-1.4703-1.5587-3.4738-1.3635-5.5106z"
  })];
};

exports.default = _default;